<h1>{{ "settings.account.code.title" | translate }}</h1>
<h3>{{ "settings.account.code.subtitle" | translate }}</h3>
<div class="tracking-script-wrapper">
  <div (click)="copyTrackingCodeToClipboard()" class="clickable" matTooltip="{{ 'settings.account.code.tooltip' | translate }}" matTooltipPosition="below">
    <app-code-snippet language="xml" [code]="trackingCode"></app-code-snippet>
  </div>
</div>
